<div class="container-fluid">
    <div class="content-wrap4">
        <div class="width50">
            <ul class="nav nav-pills mb-1 mt-4" id="pills-tab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" *ngIf="superverifier" id="pills-home-tab" data-toggle="pill"
                        (click)="getTab('statistics')" href="#pills-home" role="tab" aria-controls="pills-home"
                        aria-selected="true">Yearly statistics</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile"
                        (click)="getTab('performance')" role="tab" aria-controls="pills-profile"
                        aria-selected="true">Performance</a>
                </li>
            </ul>
        </div>

        <div *ngIf="statistics" class="width50">
            <!-- <input type="number" placeholder="YYYY" min="2017" max="2100"> -->

            <!-- <select class="select-year" [(ngModel)]="selectYear" (change)="yearChage()">
                <option selected value="2021">2021</option>
                <option value="2020">2020</option>
                <option value="2019">2019</option>
            </select> -->
            <select name="year" id="year" class="select-year" [(ngModel)]="selectYear" (change)='yearChage()' >
                <option *ngFor="let option of yearDropDown" [value]="option.finYear" >{{option.finYear}}</option>
            </select>
            <!-- <select formControlName="year" class="select-year" id="streamid"
                placeholder="Select Year" (change)='yearChage()' [(ngModel)]="selectYear">
                <option value="undefined" disabled selected> Please select Year </option>
                <option *ngFor="let year of yearDropDown" [ngValue]="year.id">
                    {{year.finYear}}</option>
            </select> -->
            <label class="select-label">Select a year to view the stats</label>
        </div>
    </div>
    <div class="clear-both"></div>
    <div class="content-wrap2 min-ht500">
        <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" *ngIf="superverifier" id="pills-home" role="tabpanel"
                aria-labelledby="pills-home-tab">
                <div class="row">
                    <div class="col-xl-4 col-lg-12">
                        <div class="dashboard-card">
                            <h3 class="stats-hd">Current Week</h3>
                            <div class="d-flex justify-content-center">
                                <div class="">
                                    <div class="circle-wrap stat-color-green">
                                        <p class="stat-num">{{weekNew}}</p>
                                    </div>
                                    <p class="stats-title stat-text-green">New</p>
                                </div>
                                <div class="mr020">
                                    <div class="circle-wrap stat-color-blue">
                                        <p class="stat-num">{{weekClosed}}</p>
                                    </div>
                                    <p class="stats-title stat-text-blue">Closed</p>
                                </div>
                                <div class="">
                                    <div class="circle-wrap stat-color-pink">
                                        <p class="stat-num">{{weekDisputes}}</p>
                                    </div>
                                    <p class="stats-title stat-text-pink">Disputes</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-12">
                        <div class="dashboard-card">
                            <h3 class="stats-hd">Current Month</h3>
                            <div class="d-flex justify-content-center">
                                <div class="">
                                    <div class="circle-wrap stat-color-green">
                                        <p class="stat-num">{{monthNew}}</p>
                                    </div>
                                    <p class="stats-title stat-text-green">New</p>
                                </div>
                                <div class="mr020">
                                    <div class="circle-wrap stat-color-blue">
                                        <p class="stat-num">{{monthClosed}}</p>
                                    </div>
                                    <p class="stats-title stat-text-blue">Closed</p>
                                </div>
                                <div class="">
                                    <div class="circle-wrap stat-color-pink">
                                        <p class="stat-num">{{monthDisputes}}</p>
                                    </div>
                                    <p class="stats-title stat-text-pink">Disputes</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-12">
                        <div class="dashboard-card">
                            <h3 class="stats-hd">Current Year</h3>
                            <div class="d-flex justify-content-center">
                                <div class="">
                                    <div class="circle-wrap stat-color-green">
                                        <p class="stat-num">{{yearNew}}</p>
                                    </div>
                                    <p class="stats-title stat-text-green">New</p>
                                </div>
                                <div class="mr020">
                                    <div class="circle-wrap stat-color-blue">
                                        <p class="stat-num">{{yearClosed}}</p>
                                    </div>
                                    <p class="stats-title stat-text-blue">Closed</p>
                                </div>
                                <div class="">
                                    <div class="circle-wrap stat-color-pink">
                                        <p class="stat-num">{{yearDisputes}}</p>
                                    </div>
                                    <p class="stats-title stat-text-pink">Disputes</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-xl-4 col-lg-12">
                        <div class="dashboard-card2">
                            <h3 class="stats-hd">Financial stats</h3>
                            <div class="line"></div>
                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <label class="date-label">From</label>
                                    <input type="date" class="stat-date" (change)="firstDateChange()"
                                        [(ngModel)]="firstDate" [max]="getToday()">
                                </div>
                                <div class="col-md-6">
                                    <label class="date-label">Till</label>
                                    <input type="date" class="stat-date" (change)="lastDateChange()" [max]="getToday()"
                                        [(ngModel)]="lastDate">
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-12">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>Company</th>
                                                <th>University Amount (&#8377;)</th>
                                                <th>Our Amount (&#8377;)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let data of getFinancialStatResponse">
                                                <td>{{data.compnayNm}}</td>
                                                <td>{{data.universityamt}}</td>
                                                <td>{{data.secureAmt}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-8 col-lg-12">
                        <div class="row">
                            <div class="col-xl-6 col-lg-12">
                                <div class="dashboard-card3">
                                    <h3 class="stats-hd">Top 10 Employers</h3>
                                    <div class="line"></div>
                                    <app-pie-chart-top10 [count]="selectYear"></app-pie-chart-top10>
                                </div>
                                <div class="dashboard-card3 mt-4">
                                    <h3 class="stats-hd">Revenue by Year</h3>
                                    <div class="line"></div>
                                    <app-pie-chart-year-revenue [countRevenue]="selectYear">
                                    </app-pie-chart-year-revenue>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-12">
                                <div class="dashboard-card3">
                                    <h3 class="stats-hd">Requests Ratio</h3>
                                    <div class="line"></div>
                                    <app-pie-chart-request-ratio [countRequests]="selectYear">
                                    </app-pie-chart-request-ratio>
                                </div>
                                <div class="dashboard-card3 mt-4">
                                    <h3 class="stats-hd">Dispute Ratio</h3>
                                    <div class="line"></div>
                                    <app-pie-chart-dispute-ratio [countDispute]="selectYear">
                                    </app-pie-chart-dispute-ratio>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                <div class="tab-pane fade show active" id="pills-profile" role="tabpanel"
                    aria-labelledby="pills-home-tab">

                    <div class="row mt-4">
                        <div class="col-xl-4 col-lg-12">
                            <div class="dashboard-card2">
                                <h3 class="stats-hd">Online Verifiers</h3>
                                <div class="line"></div>
                                <div class="row mt-3">
                                    <div class="col-md-6">
                                        <label class="date-label">From</label>
                                        <input type="date" class="stat-date" (change)="firstDateChangeNew()"
                                            [max]="getToday()" [(ngModel)]="firstDateNew">
                                    </div>
                                    <div class="col-md-6">
                                        <label class="date-label">Till</label>
                                        <input type="date" class="stat-date" (change)="lastDateChangeNew()"
                                            [max]="getToday()" [(ngModel)]="lastDateNew">
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-12">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>Verified Id</th>
                                                    <th>Name</th>
                                                    <th>Record Processed</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let data of getOnlineVerifiers">
                                                    <td>{{data.verId}}</td>
                                                    <td>{{data.fullNm}}</td>
                                                    <td>{{data.count}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-8 col-lg-12">
                            <div class="row">
                                <div class="col-xl-6 col-lg-12">
                                    <div class="dashboard-card3">
                                        <h3 class="stats-hd">Verifier Performance- Monthly</h3>
                                        <div class="line"></div>
                                        <div class="row mt-3">
                                            <div class="col-md-6">
                                                <label class="date-label">Select Month</label>
                                                <input type="month" class="stat-date" [(ngModel)]="monthyear"
                                                    (change)="changemonth()" name="start">
                                                <!-- <input type="date" class="stat-date" (change)="firstDateChange()"  [(ngModel)]="firstDate" > -->
                                            </div>

                                        </div>
                                        <app-bar-chart-monthly [countMonthly]="monthyearFormat"></app-bar-chart-monthly>
                                        <!-- <app-bar-chart-monthly [countMonthly]="monthyearFormat"></app-bar-chart-monthly> -->
                                    </div>

                                </div>
                                <div class="col-xl-6 col-lg-12">
                                    <div class="dashboard-card3">
                                        <h3 class="stats-hd">Verifier Performance- Daily</h3>
                                        <div class="line"></div>
                                        <div class="row mt-3">
                                            <div class="col-md-6">
                                                <label class="date-label">Select Date</label>
                                                <input type="date" class="stat-date" [(ngModel)]="datewise"
                                                    (change)="changedate()" name="start" [max]="getToday()">
                                                <!-- <input type="date" class="stat-date" (change)="firstDateChange()"  [(ngModel)]="firstDate" > -->
                                            </div>

                                        </div>
                                        <app-bar-chart-daily [countDaily]="datewise"></app-bar-chart-daily>
                                        <!-- <app-pie-chart-request-ratio [countRequests]="selectYear"></app-pie-chart-request-ratio> -->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>